

export const getBoolByLsnCode = (lsnCode) => ({
  ice1: lsnCode === 'ice1',
  ice2: lsnCode === 'ice2',
  ice3: lsnCode === 'ice3',
  ice4: lsnCode === 'ice4',
  ice5: lsnCode === 'ice5',
  ice6: lsnCode === 'ice6',
});